import { ZoneCalcMethod } from '@trainme/db/client';
import type { PlanGoal } from '@trainme/db/client';
import type { TrainingSettingInput, SportsSpeeds } from './types';
import sportsSpeeds from './data/defaultSportsSpeeds.json';

export const zoneColors = {
  'zone-1': 'rgb(42, 97, 124)',
  'zone-2': 'rgb(130, 202, 157)',
  'zone-3': 'rgb(255, 198, 88)',
  'zone-4': 'rgb(255, 115, 0)',
  'zone-5': 'rgb(231, 33, 33)',
  'zone-6': 'rgb(194, 47, 197)',
  highlight: 'rgb(253, 230, 138)',
} as const;

export const PLAN_GOALS: Array<{ value: PlanGoal; label: string }> = [
  { value: 'Marathon', label: 'Marathon' },
  { value: 'HalfMarathon', label: 'Half Marathon' },
  { value: 'Triathlon', label: 'Triathlon' },
  { value: 'Swimming', label: 'Swimming' },
  { value: 'TenKRun', label: '10K Run' },
  { value: 'FiveKRun', label: '5K Run' },
  { value: 'HappyRun', label: 'Happy Run' },
];

export const DEFAULT_DISTANCE_BY_GOAL: Record<PlanGoal, number> = {
  Marathon: 42.2,
  HalfMarathon: 21.1,
  Triathlon: 51.5,
  Swimming: 2,
  TenKRun: 10,
  FiveKRun: 5,
  HappyRun: 5,
};

const DEFAULT_ZONE_CALC_METHOD: ZoneCalcMethod = ZoneCalcMethod.Zoladz;

export const DEFAULT_SPORT_SPEEDS: SportsSpeeds = sportsSpeeds as SportsSpeeds;

export const defaultSettings: TrainingSettingInput = {
  maxHeartRate: 0,
  restHeartRate: 0,
  ftp: 0,
  createdAt: new Date(),
  updatedAt: new Date(),
  sportsTypes: [],
  sportsSpeeds: DEFAULT_SPORT_SPEEDS,
  zoneCalcMethod: DEFAULT_ZONE_CALC_METHOD,
  unitSystem: 'scientific',
  user: {
    connect: {
      id: '',
    },
  },
};

export const workoutStepsExampleLines = [
  '5min Z2 HR Warm up',
  '20min Z3 HR active',
  '5min Z1 HR cool down',
];

export const workoutStepsInputPlaceholder = `
Example steps:

-----------------------------
${workoutStepsExampleLines.join('\n')}
-----------------------------

Each line is a step. '5min' means 5 minutes, 'Z1' means zone one.`;

export { WorkoutStatus } from './types';
